export default "__VITE_ASSET__B$YG53Kc__"